import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SingleDatePicker } from 'react-dates';

class DatePicker extends Component {
  constructor(props) {
    super(props);

    this.state = {
      focused: false,
    };
  }

  render() {
    const { focused } = this.state;
    const { value, onChange } = this.props;

    return (
      <SingleDatePicker
        placeholder="Datum"
        focused={focused}
        onFocusChange={e => this.setState({ focused: e.focused })}
        date={value}
        onDateChange={onChange}
        keepOpenOnDateSelect={false}
        hideKeyboardShortcutsPanel
      />
    );
  }
}

DatePicker.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};

DatePicker.defaultProps = {
  value: null,
};

export default DatePicker;
